module.exports = __webpack_public_path__ + "static/media/ok-logo.86ffa05a.svg";